import type { CheckoutTravelDocs, CheckoutTravelDocsAck } from '@voll-intelligence/genui-contract';

/** Seção à vista com algum item ainda sem o «Tenho»: o pedido não sai. */
export function travelDocsPending(
  docs: CheckoutTravelDocs | null | undefined,
  checked: readonly string[],
): boolean {
  return Boolean(
    docs?.blocks.some((block) => block.items.some((item) => !checked.includes(item.id))),
  );
}

/** O que o viajante viu e confirmou: a fonte e o status de cada item. */
export function travelDocsAck(docs: CheckoutTravelDocs): CheckoutTravelDocsAck {
  return {
    source: docs.source,
    items: docs.blocks.flatMap((block) => block.items.map(({ id, status }) => ({ id, status }))),
  };
}
